import { render } from "./NavButton.vue?vue&type=template&id=75624691&ts=true"
import script from "./NavButton.vue?vue&type=script&lang=ts"
export * from "./NavButton.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__